import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { isInputCarretAtBeggining } from 'lib/utils/dom';
import { ValueFieldData } from 'lib/form/value-field-data';
import Styled from 'lib/styles/styled-deprecated';
import { keyBackSpacePressed, keyEnterPressed, keyDownPressed, keyUpPressed } from 'lib/key-code/key-code';

import AutocompleteView from 'four-nets/ui/autocomplete/autocomplete-view';

import defaultStyles from './form-autocomplete-view.scss';

@Styled(defaultStyles)
@observer
class FormAutocompleteView extends React.Component {
    autocomplete: ?AutocompleteView;
    timeout: ?number;

    @observable showAutocomplete = false;

    setAutocomplete = (ref: ?AutocompleteView) => {
        this.autocomplete = ref;
    };

    componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }

    onFocus = event => {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        this.showAutocomplete = true;

        if (this.props.onFocus) {
            this.props.onFocus(event);
        }
    };

    onBlur = event => {
        // without this, the click event is not generated on item
        this.timeout = setTimeout(() => {
            this.showAutocomplete = false;
            this.timeout = null;
        }, 250);

        if (this.props.onBlur) {
            this.props.onBlur(event);
        }
    };

    onKeyDown = event => {
        const autocomplete = this.autocomplete;

        if (keyBackSpacePressed(event)) {
            if (isInputCarretAtBeggining({ element: event.target })) {
                this.props.field.data.removeLastValue();
            }
        } else if (keyDownPressed(event)) {
            if (autocomplete) {
                autocomplete.selectNext();
            }
        } else if (keyUpPressed(event)) {
            if (autocomplete) {
                autocomplete.selectPrevious();
            }
        } else if (keyEnterPressed(event)) {
            if (autocomplete && autocomplete.selected) {
                this.onItem(event, autocomplete.selected);
            }
        }

        if (this.props.onKeyDown) {
            this.props.onKeyDown(event);
        }
    };

    onItem = (event: MouseEvent, item: any) => {
        const values = this.props.field.data.fields.map(({ value }) => value);

        if (values.indexOf(item) === -1) {
            this.props.field.data.push(
                new ValueFieldData({
                    value: item,
                })
            );
        }

        this.props.searchField.data.setValue({
            value: '',
        });

        if (this.props.onItem) {
            this.props.onItem(event, item);
        }
    };

    render() {
        const {
            elementForItem,
            keyForItem,
            autocompleteItems,
            field,
            searchField,
            onItem,
            children,
            styles,
            ...rest
        } = this.props;

        const value = searchField.data.value;

        const classNames = [styles.formAutocomplete];
        if (!(autocompleteItems && value && this.showAutocomplete)) {
            classNames.push(styles.hidden);
        }

        const autocompleteElement = (
            <div className={classNames.join(' ')}>
                <AutocompleteView
                    items={autocompleteItems}
                    elementForItem={elementForItem}
                    keyForItem={keyForItem}
                    onClick={this.onItem}
                    innerRef={this.setAutocomplete}
                />
            </div>
        );

        const element = React.Children.only(children);

        return React.cloneElement(element, {
            ...rest,
            autocompleteElement,
            onKeyDown: this.onKeyDown,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
        });
    }
}

export default FormAutocompleteView;
